<script setup>
import { computed, reactive } from "vue";
import PcapFileInput from "../PcapFileInput.vue";
import { manager } from "../globals";

const state = reactive({
  downloadingExample: false,

  // computed
  statusText: null,
});

const loadDemo = (event) => {
  if (state.downloadingExample) return;
  state.downloadingExample = true;
  fetch(event.target.href)
    .then((response) => response.arrayBuffer())
    .then((buffer) => {
      state.downloadingExample = false;
      const file = new File([buffer], "shark1.pcapng");
      manager.openFile(file);
    });
};

state.statusText = computed(() => {
  if (state.downloadingExample) return "Please wait: downloading example...";
  if (manager.activeFile) return "Please wait: opening file...";

  if (manager.lastFileOpenError) {
    const { error, filename } = manager.lastFileOpenError;
    return `Error loading file ${filename}: ${error}`;
  }

  return null;
});
</script>

<template>
  <div class="welcome-container-wrap">
    <div class="welcome-container">
      <div class="welcome-bubble">Willkommen zu Wireview</div>

      <section>
        <h2>Über Wireview auf mybzu.ch</h2>
        <p>
          Verwenden Sie Wireview, um Packet-Capture-Dateien (.pcap, .pcapng,
          etc) im Web-Browser anzuschauen und zu analysieren. Wireview ist ein OpenSource-Projekt, das mit Vue.js erstellt wurde und mit
          Wireshark's WebAssembly läuft.
        </p>
        <p>
          Alle Programmaktivitäten funktionieren direkt im Browser, ohne dass Daten an einen Server weitergeleitet werden.
        </p>
        <h2>Dateien analysieren</h2>
        <p>
          Öffnen Sie eine Packet-Capture-Datei (Wireshark-Datei) auf Ihrem System mit dem ersten Symbol in der Taskliste oben links.
        </p>
        <p style="font-size:50%;" ><hr>
          Fragen zu diesem Dienst an Stephan Göldi, BFSU
        </p>
      </section>
    </div>
  </div>
</template>
<style scoped>
p {
  max-width: 80ch;
}
h2 {
  color: #888;
  margin: 0;
}
section {
  display: flex;
  flex-direction: column;
}
a.muted {
  color: inherit;
  text-decoration: underline dotted;
}
a.muted:hover {
  opacity: 0.75;
  text-decoration: underline solid;
}
.welcome-container-wrap {
  flex-grow: 1;

  display: flex;
  justify-content: center;
  background-color: white;
  line-height: 1.5;
  color: #111;
}
.welcome-container {
  width: 80vw;
  padding: 4vh 0;

  display: flex;
  flex-direction: column;
  gap: 4vh;
}
.welcome-bubble {
  align-self: flex-start;
  background-color: var(--ws-nice-blue);
  padding: 6px 9px;
  border-radius: 5px;
}
</style>
